import { DashboardComponent } from './dashboard/dashboard.component';
import { MapViewComponent } from './map-view/map-view.component';
import { MyTasksComponent } from './mytasks/mytasks.component';
import { ProblemDetailComponent } from './problem-detail/problem-detail.component';
import { ProblemLocationComponent } from './problem-location/problem-location.component';
import { ProblemHistoryComponent } from './problem-history/problem-history.component';
import { AddCaseComponent } from './add-case/add-case.component';
import { SearchComponent } from './search/search.component';
import { WorkRequestComponent } from './work-request/work-request.component';
// import { AdminComponent } from './admin/admin.component';
import { RecentProblemsComponent } from './recent-problems/recent-problems.component';
import { BatchExportComponent } from './batch-export/batch-export.component';

export const containers: any[] = [
  DashboardComponent,
  MapViewComponent,
  MyTasksComponent,
  ProblemDetailComponent,
  ProblemLocationComponent,
  ProblemHistoryComponent,
  AddCaseComponent,
  SearchComponent,
  WorkRequestComponent,
  // AdminComponent,
  RecentProblemsComponent,
  BatchExportComponent
];

export * from './dashboard/dashboard.component';
export * from './map-view/map-view.component';
export * from './mytasks/mytasks.component';
export * from './problem-detail/problem-detail.component';
export * from './problem-location/problem-location.component';
export * from './problem-history/problem-history.component';
export * from './add-case/add-case.component';
export * from './search/search.component';
export * from './work-request/work-request.component';
// export * from './admin/admin.component';
export * from './recent-problems/recent-problems.component';
export * from './batch-export/batch-export.component';
